import { JSX } from 'react';
import { translationClasses } from 'src/shared/TranslationClasses';
import { ImageAsset } from '@ahc-digital/component-library';
import { CreateImageAssetModel } from './C15ImageAsset.service';
import { C15ImageAssetProps } from './C15ImageAsset.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox } from 'src/shared/param-utils';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C15ImageAssetProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <ImageAsset
      {...CreateImageAssetModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
    />
  );
};

export default checkDatasourceForRendering<C15ImageAssetProps>(Default);
